import { Container } from '../../components';
import React, { useState, useRef } from 'react';
import { useAccountConsolidation } from '@/context/accountConsolidationContext/accountConsolidationContextProvider';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';

const AccountConsolidation = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { uploadFile } = useAccountConsolidation();
  const fileUploadRef = useRef(null);

  const handleFilesSelected = (files) => {
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append('file', files[0]);
      await uploadFile(formData);
      fileUploadRef.current.clearFiles();
      setSelectedFiles([]);
    }
  };

  return (
    <Container title="Account Consolidation File">
      <div className="flex items-center justify-center py-20 bg-gray-50">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-lg w-full">
          {/* Heading */}
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Load Account Consolidation File
          </h2>
          <p className="text-gray-500 mb-6 text-center">
            Please upload a CSV file containing customer data.
          </p>

          {/* File Upload */}
          <FileUploadTemplate
            ref={fileUploadRef}
            maxFiles={1}
            acceptedFileTypes={['.csv']}
            onFilesSelected={handleFilesSelected}
            onUpload={handleUpload}
          />

          {/* Error or Instruction Message */}
          <p className="text-center text-red-500 text-sm mb-4">
            * Note: The file should be in the following format.
          </p>

          {/* Table */}
          <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm">
            <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                    Old Account Code
                  </th>
                  <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                    New Account Code
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {/* Sample Row */}
                <tr>
                  <td className="py-2 px-4 text-center">XY0121</td>
                  <td className="py-2 px-4 text-center">XYZ0121 </td>
                </tr>
                {/* Additional rows can be added here */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AccountConsolidation;
